import type { WorkshopNavItem } from './workshopNavTypes';

export const WORKSHOP_PAYMENTS_NAV: WorkshopNavItem[] = [
    { resource: 'jobCardRecovery', label: 'Job Card Recovery' },
    { resource: 'jobCardTypeBilling', label: 'Job Card Billing' },
    { resource: 'jobCardBillingRecovery', label: 'Job Card Billing Recovery' },
    { resource: 'customerPayments', label: 'Payments' },
];
